export default __webpack_public_path__ + "static/media/transportbus.f3be10a0.png";